import { useTheme } from "@mui/material/styles";
import {
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarProps,
  ToolbarPropsOverrides,
} from "@mui/x-data-grid-pro";
import React from "react";

type OtherDealerInventoryToolBarProps = GridToolbarProps &
  ToolbarPropsOverrides;

const OtherDealerInventoryToolBar: React.FC<
  OtherDealerInventoryToolBarProps
> = () => {
  const theme = useTheme();

  return (
    <GridToolbarContainer
      sx={{
        display: "flex",
        gap: theme.tokens.FuelSpacing6,
        justifyContent: "space-between",
        alignItems: "center",
        padding: "1rem",
      }}
      data-testid="other-dealer-inventory-toolbar"
    >
      <GridToolbarColumnsButton
        data-testid="inventory-toolbar-column-button"
        slotProps={{
          button: {
            variant: "text",
            size: "medium",
          },
        }}
      />
    </GridToolbarContainer>
  );
};

export default OtherDealerInventoryToolBar;
